import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { action } from 'satcheljs';
import type {
    ComposeFormType,
    FullComposeFormViewType,
    QuickComposeViewType,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import type { QuickComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

/**
 * Initializes compose store when given a calendarEvent
 */
export let initializeCompose = action(
    'initializeCompose',
    (event: CalendarEvent, formType?: ComposeFormType) => ({
        event,
        formType,
    })
);

export let resetFullCompose = action(
    'resetFullCompose',
    (event: CalendarEvent, viewType: FullComposeFormViewType) => ({
        event,
        viewType,
    })
);

export let resetQuickCompose = action(
    'resetQuickCompose',
    (
        event: CalendarEvent,
        entrySource: QuickComposeEntrySourceType,
        viewType: QuickComposeViewType,
        anchor: HTMLDivElement | string
    ) => ({
        event,
        entrySource,
        viewType,
        anchor,
    })
);
